import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface PropertyFormData {
  address?: any;
  agents?: any;
  areasNearby?: any;
  contacts?: {
    owners?: any;
    customers?: any;
  };
  details?: any;
  proposals?: {
    proposal?: any;
    counter?: any;
  };
}

@Injectable({ providedIn: "root" })
export class PropertyDataService {
  private currentIdFilterAgentSubject: BehaviorSubject<number>;
  public currentIdFilterAgent: Observable<number>;
  private currentAgentListSubject: BehaviorSubject<any>;
  public currentAgentList: Observable<any>;
  private propertyFormDataSubject = new BehaviorSubject<PropertyFormData>({});
  public propertyFormData$ = this.propertyFormDataSubject.asObservable();
  private cmiFormDataSubject = new BehaviorSubject<any>({});
  public cmiFormData$ = this.cmiFormDataSubject.asObservable();
  private listingImagesSubject = new BehaviorSubject<File[]>([]);
  public listingImages$ = this.listingImagesSubject.asObservable();

  constructor() {
    this.currentIdFilterAgentSubject = new BehaviorSubject<number>(0);
    this.currentIdFilterAgent = this.currentIdFilterAgentSubject.asObservable();
    this.removeIdFilterAgent();
    this.currentAgentListSubject = new BehaviorSubject<any>([]);
    this.currentAgentList = this.currentAgentListSubject.asObservable();
  }

  public get currentUserValue(): number {
    return this.currentIdFilterAgentSubject.value;
  }
  public get currentCmiValue() {
    return this.cmiFormDataSubject.value;
  }

  saveIdFilterAgent(num: number) {
    //localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentIdFilterAgentSubject.next(num);
  }
  getIdFilterAgent() {
    //localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentIdFilterAgentSubject.value;
  }

  removeIdFilterAgent() {
    //localStorage.removeItem('currentUser');
    this.currentIdFilterAgentSubject.next(0);
  }

  updateAgentList(agentList: any) {
    this.currentAgentListSubject.next(agentList);
  }

  /** Atualiza uma tab específica (details, address, agents...) */
  updateTab<K extends keyof PropertyFormData>(
    tab: K,
    data: PropertyFormData[K]
  ) {
    const curr = this.propertyFormDataSubject.value;

    this.propertyFormDataSubject.next({ ...curr, [tab]: data });
  }

  seedFromProperty(property: any) {
    if (!property) return;

    const mainAgent =
      property?.propertyAgents?.find((agent: any) => agent.isMain) ?? null;

    const agentData = mainAgent
      ? {
          id: mainAgent.id,
          name: mainAgent.user?.name ?? mainAgent.name ?? "",
          email: mainAgent.user?.email ?? mainAgent.email ?? "",
          fiscalIdentification:
            mainAgent.userAddress?.fiscalIdentification ?? "",
        }
      : null;

    const seed: PropertyFormData = {
      details: property.details ?? {},
      address: property.address ?? {},
      agents: { mainAgent: agentData },
      areasNearby: property.areasNearby ?? {},
      contacts: {
        customers: property.propertyCostumersContacts.costumers ?? [],
        owners: property.propertyOwnersContacts.owners ?? [],
      },
      proposals: property.proposals ?? [],
    };

    this.propertyFormDataSubject.next({
      ...this.propertyFormDataSubject.value,
      ...seed,
    });
  }

  seedFromCMI(data: any) {
    if (!data) return;
    const seed: any = {
      contractNumber: data?.contractNumber ?? null,
      startDateMediation: data?.startDateMediation ?? null,
      endDateMediation: data?.endDateMediation ?? null,
      defineEndDate: data?.defineEndDate ?? null,
      autoRenewal: data?.autoRenewal ?? null,
    };

    this.cmiFormDataSubject.next(seed);
  }

  resetPropertyFormData() {
    this.propertyFormDataSubject.next({});
    this.listingImagesSubject.next([]);
  }

  /** Imagens do imóvel ainda em memória (não guardadas), usadas pela geração de descrição com IA */
  get listingImages(): File[] {
    return this.listingImagesSubject.value;
  }

  updateListingImages(files: File[]) {
    this.listingImagesSubject.next(files ?? []);
  }
}
